import { LuExternalLink, LuTriangleAlert } from 'react-icons/lu'

import { ENVIRONMENT } from '@/config/constants'

const DevEnvWarning = () => {
  if (ENVIRONMENT !== 'development') return null

  return (
    <div className='bg-gradient-to-bl from-helpers-warning-main to-helpers-warning-button p-4 text-xs text-orange-100'>
      <LuTriangleAlert className='mb-2 h-6 w-6 text-white' />
      <div>
        This is a development environment. To use the production portal, please
        go to{' '}
        <a
          href='https://hubble.gspcloud.com'
          target='_blank'
          rel='noopener noreferrer'
          className='font-bold text-orange-100 hover:text-white'
        >
          Hubble Prod
          <LuExternalLink className='mb-px ml-1 inline h-3 w-3' />
        </a>
      </div>
    </div>
  )
}

export default DevEnvWarning
